import { useState } from "react";
import { createUseStyles } from "react-jss";
import produce from "immer";
import SidebarLightbox from "../../refresh/SidebarLightbox";
import ImageSelectorButton from "../../refresh/selectors/ImageSelectorButton";
import GenericOptions from "../GenericOptions";
import styles from "./sharedStyles";
import RedButton from "../../refresh/RedButton";
import TextInput from "../../refresh/inputs/TextInput";
import Label from "../../refresh/Label";
import ListButtons from "../../refresh/ListButtons";

const useStyles = createUseStyles({
  ...styles,
  scene: {
    position: "relative",
    "min-height": 80,
  },
});

const EditTimelineHotspot = ({
  show,
  hotspot,
  onClose,
  onComplete,
  account,
  images,
  activeImage,
}) => {
  const [config, setConfig] = useState(
    produce(hotspot, draft => {
      draft.options.scenes ??= [
        {
          id: Date.now(),
          scene: activeImage,
          name: images[activeImage].name,
          date: "",
        },
      ];
    }),
  );
  const classes = useStyles();

  return (
    <SidebarLightbox
      show={show}
      onClose={onClose}
      sidebar={
        <>
          <h1 className={classes.title}>Edit Timeline Hotspot</h1>
          <p className={classes.subtitle}>
            Link to multiple different scenes at once.
          </p>
          <div className={classes.grow} />
        </>
      }
    >
      <div className={classes.options}>
        <GenericOptions
          icon="Timeline"
          config={config}
          setConfig={setConfig}
          account={account}
        />
        <hr />
        {config.options.scenes.map(({ id, scene, name, date }, i) => (
          <div className={classes.scene} key={id}>
            <Label name={`Scene ${i + 1}`} required style={{ paddingLeft: 35 }}>
              <ListButtons list="scenes" index={i} setConfig={setConfig} />
              <ImageSelectorButton
                images={images}
                value={scene}
                onChange={image =>
                  setConfig(
                    produce(draft => {
                      const oldImageName =
                        images[draft.options.scenes[i].scene].name;
                      if (draft.options.scenes[i].name === oldImageName)
                        draft.options.scenes[i].name = image.name;
                      draft.options.scenes[i].scene = image.id;
                    }),
                  )
                }
              />
              <TextInput
                label="scene name"
                required
                value={name}
                onChange={name =>
                  setConfig(
                    produce(c => {
                      c.options.scenes[i].name = name;
                    }),
                  )
                }
              />
              <TextInput
                label="date/subtitle"
                required
                value={date}
                onChange={date =>
                  setConfig(
                    produce(c => {
                      c.options.scenes[i].date = date;
                    }),
                  )
                }
              />
            </Label>
            <hr />
          </div>
        ))}
        <Label name="add another scene" optional>
          <ImageSelectorButton
            images={images}
            value={null}
            onChange={image =>
              setConfig(
                produce(draft => {
                  draft.options.scenes.push({
                    id: Date.now(),
                    scene: image.id,
                    name: image.name,
                    date: "",
                  });
                }),
              )
            }
          />
        </Label>
        <RedButton
          disabled={
            !(
              (
                config.tooltip &&
                config.options.title &&
                config.options.scenes.length > 0
              )
              // maybe add a reduce function to check
              // each one has values
            )
          }
          onClick={() => onComplete(config)}
        >
          Save
        </RedButton>
      </div>
    </SidebarLightbox>
  );
};

export default EditTimelineHotspot;
